"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var interfaces_1 = require("../../interfaces");
var getRegistrationData = function () {
    return {
        tournamentStatus: interfaces_1.TournamentStatus.OPENED,
        frameworks: ['java', 'dotnet', 'nodejs'],
        status: interfaces_1.TournamentProgressStatus.INVITED,
        nickname: 'nickname',
        avatar: 'user-1',
        framework: 'java',
        tournamentName: 'My Tournament',
        tournamentAvatar: 'tournament-1',
    };
};
exports.default = getRegistrationData;
